import Axios from 'axios'
import config from '../config'
import { debug } from '../utilities/logger'

export const askResetPassword = async ({ email }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/forgot-password?email=${email}`
  return Axios.post(URL, null)
}

export const authenticate = async ({ email, password, type, referralCode }) => {
  const url = `${config.baseURL}${config.oauthURL}/token`
  const formData = new FormData()
  formData.append('grant_type', type)
  formData.append('scope', 'read write')
  formData.append('username', email)
  formData.append('password', password)
  formData.append('realm', 'customer')
  formData.append('referralCode', referralCode)

  return Axios.post(url, formData, {
    auth: {
      username: config.oauth_app_id,
      password: config.oauth_app_secret
    }})
}

export const refresh = async ({ refresh }) => {
  const URL = `${config.baseURL}${config.oauthURL}/token`
  const formData = new FormData()
  formData.append('grant_type', 'refresh_token')
  formData.append('scope', 'read write')
  formData.append('realm', 'customer')
  formData.append('refresh_token', refresh)

  return Axios.post(URL, formData, {
    auth: {
      username: config.oauth_app_id,
      password: config.oauth_app_secret
    }})
}

export const register = async (
  { email, firstName, lastName, newsletter, birthdate, nationality, country, address, couponCodeId },
  { password, referralCode, proBusinessReferralCode }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/account/register`
  const params = {
    'email': email,
    'firstName': firstName,
    'lastName': lastName,
    'newsletter': newsletter,
    'birthdate': birthdate,
    'nationality': nationality ? nationality.toUpperCase() : '',
    'country': country ? country.toUpperCase() : '',
    'address': address,
    'couponCodeId': couponCodeId
  }
  if (password) {
    params['password'] = password
  } else if (referralCode) {
    params['professionalReferralCode'] = referralCode
  } else {
    debug('[api][register] Unable to find a strategy to register account.')
    // TODO(): Return a IHM error
  }

  // Pro business referral (apport d'affaire L2) - independent from sponsor/referralCode system
  if (proBusinessReferralCode) {
    params['proBusinessReferralCode'] = proBusinessReferralCode
  }

  return Axios.post(URL, params)
}

export const disconnectConnectedAs = async () => {
  const URL = `${config.baseURL}${config.apiURL}admin/switch_user_exit`
  try {
    await Axios.get(URL)
  } catch (e) {
    debug(`[api][authentication.disconnectConnectedAs] Unable to disconnect impersonated user.`)
  }
}

export const resetPassword = async ({ role, key, password }) => {
  const URL = `${config.baseURL}${config.apiURL}${role}/account/reset-password`
  const response = await Axios.post(URL, { key, password })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/authentication.js